
/*
 * @Author: 朱占为
 * @LastEditors: 邱扬
 * @description: 接口请求
 * @Date: 2021-06-09 20:11:01
 * @LastEditTime: 2021-10-29 14:12:47
 */

import axios from 'axios';
import { Dialog } from 'vant';
import Cookie from 'js-cookie'
import { big_data_error_num } from './_error.js'

/**
 *  UNKNOWN(1),   不知道啥错误
    COMMON(2),  提示
    ALERT(3),   弹窗
    EMAIL_NOT_VERIFY(4),   邮箱验证错误
    BIG_DATA(5)    大数据错误
 * @param {*} errorInfo 
 * @param {*} vm 
 */
function dealErrorInfo(errorInfo, vm, error_process) {
  const type = errorInfo.EX ? errorInfo.EX.type : null
  const e_info = errorInfo.E
  if (typeof error_process === 'function') {
    error_process(type)
  }
  switch (type) {
    case 1:
    case 4: {
      Dialog({
        type: 'error',
        message: e_info
      })
      return null
    }
    case 2: {
      Dialog({
        type: 'error',
        message: e_info
      })
      return null
    }
    case 3: {
      Dialog({
        type: 'error',
        message: e_info
      })
      return null
    }
    case 5: {
      return {
        data: big_data_error_num
      }
    }

    default: {
      return null
    }
  }
}

axios.defaults.withCredentials = true;

// 基础地址
let baseURL = '/myApi';
if (process.env.NODE_ENV === 'production') {
  baseURL = process.env.common['API'];
}

const service = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30000
});
// 请求拦截器
service.interceptors.request.use(config => {
  config.headers['Time-Zone'] = new Date().getTimezoneOffset()
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
  // 响应正确
  if (response.status >= 200 && response.status <= 210) {
    const data = response.data;
    if (!data.E) {
      return {
        code: 0,
        data: data.P
      };
    } else {
      return {
        code: -1,
        msg: data.E
      };
    }
  }
  return {
    code: -1,
    msg: response.data.E
  };

},
error => {
  // 处理时间超时问题
  if (error.response) {
    const status = error.response.status;
    const data = error.response.data;
    console.log(status, data)
    if (error.response.status >= 400) {
      return dealErrorInfo(data)
    }
    // 跳转登录页
    if (status === 401) {
      // removeToken();
      // router.replace('/login').catch(_ => {});
      //Cookie.remove('myToken')
      Cookie.remove('myToken')
      location.replace('/user/login')
      return
    } else if (error.message === 'cancel') return
    if (status === 502) {
      Dialog({
        type: 'error',
        message: 'The network is busy, and please try again later.(502)'
      })
      return
    } else if (error.message === 'Network Error') {
      Dialog({
        type: 'error',
        message: 'The network is busy, and please try again later.(Network Error)'
      })
    } else {
      // if (Object.prototype.hasOwnProperty.call(data,'E')) {
      //   Dialog.alert({
      //     title: 'err',
      //     message: error.response.data.E,
      //     confirmButtonText:'确认'
      //   })
      // }
      return {
        code: -1,
        msg: data.E
      };
      // return Promise.resolve(error.response.data);
    }
  } else {
    Dialog({
      type: 'error',
      message: 'The network is busy, and please try again later.(Network Error)'
    })
    return {
      code: -1,
      msg: 'timeOut'
    };
  }
});

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  try {
    return service({
      url,
      params,
      method: 'GET'
    });
  } catch (error) {
    console.error('get:', error);
  }
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  try {
    return service({
      url,
      method: 'POST',
      data
    });
  } catch (error) {
    console.error('post:', error);
  }
}
